import type { ApiError } from 'data';

export const getLocalPartiesErrorMessage = (error: ApiError | Error, hasList: boolean) => {
  const { status, body } = error as { status?: number; body?: { message?: string } };
  const listSuffix = hasList ? ' Showing the last fetched list.' : '';

  if (status === 404) {
    return 'Participant not found.';
  }
  if (status === 503) {
    return `Could not reach the participant.${listSuffix}`;
  }
  // fetch rejects with a TypeError when the request doesn't get a readable response (e.g. the API is down)
  if (error instanceof TypeError) {
    return `Could not reach the server.${listSuffix}`;
  }
  const message = (body?.message || error.message).replace(/\.?$/, '.');
  return `Failed to load local parties: ${message}${listSuffix}`;
};
